import { useAppSelector } from 'hooks';

import { AuthTags } from '~constants/authTags';
import { selectUserTags } from '~main/selectors/login';

// Only users with `supportathome-claims:Unlock` may apply reverse status
// transitions — walking an invoice back down the flow, e.g. Paid -> Sent -> Not
// Sent. Strictly narrower than `useCanManageInvoiceStatus`: a super-admin can
// manage statuses but cannot reverse them without the tag. The API enforces the
// same rule; this hook only controls whether the options are offered in the UI.
export const useCanUnlockInvoiceStatus = (): boolean => {
  const tags = useAppSelector(selectUserTags);
  return tags.includes(AuthTags.SUPPORTATHOME.CLAIMS.UNLOCK);
};
